import * as Yup from "yup";
import MESSAGE from "~/utils/messages";
import { isValid, parse, isToday, isBefore } from "date-fns";
import { cnpjValidate } from "~/utils/tools";

export const schema = Yup.object().shape({
  Data: Yup.mixed()
    .required(MESSAGE.requiredField)
    .test({
      name: "Data",
      message: MESSAGE.invalidDate,
      test: (value) => value && isValid(parse(value, "dd/MM/yyyy", new Date())),
    })
    .test({
      name: "Data",
      message: MESSAGE.invalidPerid,
      test: (value) =>
        value &&
        parse(value, "dd/MM/yyyy", new Date()) <=
          parse(process.env.REACT_APP_END_PROMO, "dd/MM/yyyy", new Date()),
    })
    .test({
      name: "Data",
      message: MESSAGE.invalidPerid,
      test: (value) =>
        value &&
        parse(value, "dd/MM/yyyy", new Date()) >=
          parse(process.env.REACT_APP_START_PROMO, "dd/MM/yyyy", new Date()),
    })
    .test({
      name: "Data",
      message: MESSAGE.invalidDateFuture,
      test: (value) =>
        value &&
        (isToday(parse(value, "dd/MM/yyyy", new Date())) ||
          isBefore(parse(value, "dd/MM/yyyy", new Date()), new Date())),
    }),

  Numero: Yup.mixed().required(MESSAGE.requiredField),
  Cnpj: Yup.mixed()
    .required(MESSAGE.requiredField)
    .test({
      name: "Cnpj",
      message: MESSAGE.invalidCNPJ,
      test: (value) => value && cnpjValidate(value),
    }),
  Imagem: Yup.mixed().required(MESSAGE.requiredField),
  // RazaoSocial: Yup.string().required(MESSAGE.requiredField),
  // AmbienteCompra: Yup.string().required(MESSAGE.requiredField),
  // Fornecedor: Yup.string().required(MESSAGE.requiredField),
  // RazaoSocial: Yup.object().shape({
  //   label: Yup.string().required(MESSAGE.requiredSelect),
  //   value: Yup.string().required(MESSAGE.requiredSelect),
  //   id: Yup.number().required(MESSAGE.requiredSelect),
  // }),
});
